import React, { useEffect, useState } from 'react';
import { TopBanner, Nav, Footer, SUPPORT_EMAIL, APP_NAME } from './SiteChrome';
import { API_URL } from '../api';
import './site.css';

export default function DeleteAccount() {
  const [identifier, setIdentifier] = useState('');
  const [reason, setReason] = useState('');
  const [state, setState] = useState('idle'); // idle | sending | done | error
  const [error, setError] = useState('');

  useEffect(() => { document.title = 'Delete Account — SparkSync'; }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!identifier.trim()) { setError('Please enter your phone or email.'); return; }
    setState('sending'); setError('');
    try {
      const res = await fetch(`${API_URL}/content/delete-request`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ identifier: identifier.trim(), reason: reason.trim() }),
      });
      const json = await res.json();
      if (!res.ok || json.success === false) throw new Error(json.message || 'Something went wrong');
      setState('done');
    } catch (err) {
      setError(err.message); setState('error');
    }
  };

  return (
    <div className="site">
      <TopBanner />
      <Nav />
      <div className="wrap legal">
        <h1>Delete Your <span className="grad-text">Account</span></h1>
        <p>
          You can request permanent deletion of your {APP_NAME} account and personal data at any time.
          This removes your profile, photos, matches, messages and preferences.
        </p>

        <h2>What gets deleted</h2>
        <ul>
          <li>Your profile, photos and bio</li>
          <li>Your matches, likes and chat messages</li>
          <li>Your preferences and account settings</li>
        </ul>
        <p style={{ color: 'var(--muted)', fontSize: 14 }}>
          Note: We may retain limited records (e.g. transaction receipts) where required to comply with legal
          and tax obligations, as described in our Privacy Policy. Deletion is typically completed within 7 days.
        </p>

        <div className="box">
          {state === 'done' ? (
            <div>
              <h2 style={{ marginTop: 0 }}>✅ Request received</h2>
              <p>We've received your deletion request and will process it shortly. If you need anything, email us at{' '}
                <a className="grad-text" href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.</p>
            </div>
          ) : (
            <form onSubmit={submit}>
              <h2 style={{ marginTop: 0 }}>Request account deletion</h2>
              <label style={{ color: 'var(--dim)', fontSize: 14 }}>Phone number or email used to sign up</label>
              <input className="field" placeholder="+91 98765 43210 or you@example.com" value={identifier} onChange={(e) => setIdentifier(e.target.value)} />
              <label style={{ color: 'var(--dim)', fontSize: 14, display: 'block', marginTop: 14 }}>Reason (optional)</label>
              <textarea className="field" rows={3} placeholder="Tell us why you're leaving (optional)" value={reason} onChange={(e) => setReason(e.target.value)} />
              {error ? <div style={{ color: 'var(--pink)', marginTop: 12, fontWeight: 600 }}>{error}</div> : null}
              <button className="btn-grad" type="submit" style={{ marginTop: 18 }} disabled={state === 'sending'}>
                {state === 'sending' ? 'Sending…' : 'Request Deletion'}
              </button>
            </form>
          )}
        </div>

        <p style={{ marginTop: 24 }}>
          Prefer email? Send your request to <a className="grad-text" href={`mailto:${SUPPORT_EMAIL}?subject=Delete%20my%20account`}>{SUPPORT_EMAIL}</a>{' '}
          from the address linked to your account.
        </p>
      </div>
      <Footer />
    </div>
  );
}
